/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, of, take } from 'rxjs';
import { WorkspaceMemberGuard } from './workspace-member.guard';
import { WorkspaceRole } from '@workspaces/models/users';
import { getAllPathParams } from '../get-all-path-params';
import { AppState } from 'src/app/state/app.state';
import { CognitoService } from 'src/app/services/cognito.service';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceRoleGuard extends WorkspaceMemberGuard {
  constructor(
    protected override readonly route: ActivatedRoute,
    protected override readonly store: Store<AppState>,
    protected override readonly cognitoService: CognitoService
  ) {
    super(route, store, cognitoService);
  }

  override canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const pathParams = getAllPathParams(route);
    return this.roleActivationCheck(pathParams['workspaceId'], route.data['roles']).pipe(take(1));
  }

  override canActivateChild(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const pathParams = getAllPathParams(route);
    return this.roleActivationCheck(pathParams['workspaceId'], route.parent?.data['roles']).pipe(take(1));
  }

  roleActivationCheck(workspaceId: string, allowedRoles: WorkspaceRole[]) {
    return this.getUserInWorkplace(workspaceId).pipe(
      map(userInWorkspace => {
        return (allowedRoles ?? []).some(role => role === userInWorkspace?.role);
      })
    );
  }
}
